// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer } from "@components";

type Props = PropsFromLocalize;

class HelpPanelAlertDetails extends React.Component<Props> {
  get typeData() {
    return [
      {
        id: "standart-reports",
        label: this.props.t("STANDART_REPORTS"),
        details: this.props.t("STANDART_REPORTS_INTRODUCTION"),
      },
      {
        id: "my-reports",
        label: this.props.t("MY_REPORTS"),
        details: this.props.t("MY_REPORTS_INTRODUCTION"),
      },
    ];
  }

  get formatData() {
    return [
      {
        id: "positions-triggered",
        label: this.props.t("TOP_FIVE_POSITIONS_TRIGGERED_ALERTS"),
        details: this.props.t("ALERT_TOP_5_TRIGGERED_POSITIONS_DESCRIPTION"),
      },
      {
        id: "alerts-triggered",
        label: this.props.t("TOP_FIVE_ALERTS_TRIGGERED"),
        details: this.props.t("ALERT_TOP_5_ALERTS_TRIGGERED_DESCRIPTION"),
      },
      {
        id: "filters",
        label: this.props.t("QUICK_FILTERS"),
        details: this.props.t("QUICK_FILTERS_DESCRIPTION"),
      },
      {
        id: "export-button",
        label: this.props.t("EXPORT_BUTTON"),
        details: this.props.t("EXPORT_BUTTON_DESCRIPTION"),
      },
    ];
  }

  get filtersData() {
    return [
      {
        id: "date-range",
        label: this.props.t("DATE_RANGE"),
        details: this.props.t("DATE_RANGE_DESCRIPTION"),
      },
      {
        id: "from-date",
        label: this.props.t("FROM_DATE"),
        details: this.props.t("FROM_DATE_DESCRIPTION"),
      },
      {
        id: "to-date",
        label: this.props.t("TO_DATE"),
        details: this.props.t("TO_DATE_DESCRIPTION"),
      },
      {
        id: "absence-type",
        label: this.props.t("ABSENCE_TYPE"),
        details: this.props.t("ABSENCE_TYPE_DESCRIPTION"),
      },
      {
        id: "alert-types",
        label: this.props.t("ALERT_TYPES"),
        details: this.props.t("ALERT_TYPES_DESCRIPTION"),
      },
      {
        id: "include-leavers",
        label: this.props.t("INCLUDE_LEAVERS"),
        details: this.props.t("INCLUDE_LEAVERS_DESCRIPTION"),
      },
      {
        id: "with-disability",
        label: this.props.t("INCLUDE_EMPLOYEE_WITH_DISABILITY"),
        details: this.props.t("ALERT_EMPLOYEE_WITH_DISABILITY_DESCRIPTION"),
      },
      {
        id: "gender",
        label: this.props.t("GENDER"),
        details: this.props.t("GENDER_DESCRIPTION"),
      },
      {
        id: "staff-groups",
        label: this.props.t("STAFF_GROUPS"),
        details: this.props.t("ALERT_STAFF_GROUPS_DESCRIPTION"),
      },
      {
        id: "age-groups",
        label: this.props.t("AGE_GROUPS"),
        details: this.props.t("ALERT_AGE_GROUPS_DESCRIPTION"),
      },
    ];
  }

  get resultsData() {
    return [
      {
        id: "employee-ref",
        label: this.props.t("EMPLOYEE_REF"),
        details: this.props.t("EMPLOYEE_REF_DESCRIPTION"),
      },
      {
        id: "department",
        label: this.props.t("DEPARTMENT"),
        details: this.props.t("DEPARTMENT_DESCRIPTION"),
      },
      {
        id: "position",
        label: this.props.t("POSITION"),
        details: this.props.t("POSITION_DESCRIPTION"),
      },
      {
        id: "alert-triggered",
        label: this.props.t("ALERT_TRIGGERED"),
        details: this.props.t("ALERTS_TRIGGERED_DESCRIPTION"),
      },
      {
        id: "date-triggered",
        label: this.props.t("DATE_TRIGGERED"),
        details: this.props.t("DATE_TRIGGERED_DESCRIPTION"),
      },
      {
        id: "absence-dates",
        label: this.props.t("REPORT_COLUMN_ABSENCE_DATES"),
        details: this.props.t("ABSENCE_DATES_DESCRIPTION"),
      },
      {
        id: "staff-groups",
        label: this.props.t("STAFF_GROUPS"),
        details: this.props.t("STAFF_GROUPS_DESCRIPTION"),
      },
      {
        id: "disability",
        label: this.props.t("DISABILITY"),
        details: this.props.t("DISABILITY_DESCRIPTION"),
      },
      {
        id: "age-bracket",
        label: this.props.t("AGE_GROUP"),
        details: this.props.t("AGE_BRACKETS_DESCRIPTION"),
      },
      {
        id: "absence-reason",
        label: this.props.t("ABSENCE_REASON"),
        details: this.props.t("ABSENCE_REASON_DESCRIPTION"),
      },
      {
        id: "absence-status",
        label: this.props.t("ABSENCE_STATUS"),
        details: this.props.t("ABSENCE_STATUS_DESCRIPTION"),
      },
      {
        id: "gender",
        label: this.props.t("GENDER"),
        details: this.props.t("RESULT_GENDER_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("ALERT_DETAILS_INTRODUCTION")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.ALERT_DETAILS_INSTRUCTIONS}
            title={this.props.t("ALERT_DETAILS_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("TYPE")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.typeData} />
        <h6 className="font-weight-bold">{this.props.t("FORMAT")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.formatData} />
        <h6 className="font-weight-bold">{this.props.t("FILTERS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.filtersData} />
        <h6 className="font-weight-bold">{this.props.t("RESULTS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.resultsData} />
      </div>
    );
  }
}

export default localize()(HelpPanelAlertDetails);
